const oembedCache = {}

export function youtube(url) {
    if (url in oembedCache) {
        return oembedCache[url];
    }

    oembedCache[url] = fetch(`https://www.youtube.com/oembed?format=json&url=${encodeURIComponent(url)}`).then(response => { // eslint-disable-line compat/compat
        return response.json();
    });

    return oembedCache[url];
}

export function vimeo(url) {
    if (url in oembedCache) {
        return oembedCache[url];
    }

    oembedCache[url] = fetch(`https://vimeo.com/api/oembed.json?url=${encodeURIComponent(url)}`).then(response => { // eslint-disable-line compat/compat
        return response.json();
    });

    return oembedCache[url];
}

export function tiktok(url) {
    if (url in oembedCache) {
        return oembedCache[url];
    }

    oembedCache[url] = fetch(`https://www.tiktok.com/oembed?url=${encodeURIComponent(url)}`).then(response => { // eslint-disable-line compat/compat
        return response.json();
    });

    return oembedCache[url];
}

export default {
    youtube,
    vimeo,
    tiktok,
}
